import React from 'react';
import ReactDOM from 'react-dom';
import './globals.css';
import App from './App';
import About from './About';
import Pro from './pro';
import {
    createBrowserRouter,
    RouterProvider,
  } from "react-router-dom";

  const router = createBrowserRouter([
    {
      path: "/",
      element: <App/>,
    },
    {
        path: "/about",
        element: <About/>,
      },
      {
          path: "/pro",
          element: <Pro/>,
        }

  ]);


ReactDOM.render(<RouterProvider router={router}/>,document.querySelector("#root"));